/*
 * @Author: dgq 370541946@qq.com
 * @Date: 2025-03-13 14:42:56
 * @FilePath: /insuranceagent-ui/src/router/router.js
 * @Description: 路由配置
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import PageRouter from './page/'
import ViewsRouter from './views/'
import AvueRouter from './avue-router'
import Store from '../store/'

Vue.use(VueRouter)
//创建路由
export const createRouter = () =>
	new VueRouter({
		routes: [...PageRouter, ...ViewsRouter],
	})

const Router = createRouter()
AvueRouter.install(Router, Store)
Router.$avueRouter.formatRoutes(Store.state.user.menu, true)

Router.beforeEach((to, from, next) => {
	next()
})

Router.afterEach((to, from) => {})

// 重置路由
export function resetRouter() {
	const newRouter = createRouter()
	Router.matcher = newRouter.matcher
	AvueRouter.install(Router, Store)
}

export default Router
